/* ============================================================
   accordion.js — de accordeons in de voet en op de productpagina.

   De productpagina gebruikt <details>/<summary>: dat werkt zonder JavaScript en
   is met het toetsenbord te bedienen. Alleen de voetkolommen hebben een script
   nodig, want daar is het gedrag anders per breedte: op desktop staat alles open
   en is de kop géén knop, op mobiel klapt hij open en dicht.

   Die regel staat in de CSS van het origineel (`.o-accordion--mobile
   .o-accordion__heading { pointer-events: none }` vanaf 1024 px); dit script zorgt
   dat de aria-status daarmee meebeweegt, anders belooft een schermlezer een
   knop die er op desktop niet is.

   Toegankelijkheid (04-09-2026):

   - `aria-expanded` staat op de knop zelf en `aria-controls` wijst naar het
     paneel; dat deed dit script al en dat blijft zo. Nieuw is dat de status ook
     klopt als het paneel van buitenaf opengaat.
   - Het echte gat zat in het paneel. `.o-accordion__content` is dicht met
     `max-height: 0; overflow: hidden` (thema.css r. 84-90). Dat verbergt het
     beeld, maar niet de tabvolgorde: op mobiel tabde je door een half dozijn
     voetlinks die niemand kon zien, zonder zichtbare focus. `inert` haalt de
     tak uit de tabvolgorde én uit de toegankelijkheidsboom en verandert niets
     aan de opmaak, dus dat is hier het juiste gereedschap — geen `hidden`, want
     dan verdwijnt de uitklap-overgang.
   - Bewust níét gedaan: de kop is een `<h3>` in `sections/footer.liquid` en
     krijgt hier `role="button"`, wat de kopstructuur van de voet op mobiel
     opheft. Netjes zou `<h3><button>` zijn, maar die markup hoort in
     footer.liquid en dat bestand is van een andere baan. Staat als openstaand
     punt in BUILD-LOG.md.
   ============================================================ */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');

  document.querySelectorAll('.js-accordion').forEach((accordeon) => {
    const kop = accordeon.querySelector('.js-accordion-trigger');
    const inhoud = accordeon.querySelector('.o-accordion__content');
    if (!kop || !inhoud) return;

    if (!inhoud.id) inhoud.id = `accordeon-${Math.round(performance.now() * 1000)}`;

    /* Eén plek waar open/dicht in alle drie de talen wordt uitgedrukt: de
       klasse (opmaak), aria-expanded (schermlezer) en inert (toetsenbord). */
    const zet = (open) => {
      accordeon.classList.toggle('is-open', open);
      kop.setAttribute('aria-expanded', String(open));
      inhoud.inert = !open;
    };

    const stelIn = () => {
      if (desktop.matches) {
        kop.removeAttribute('role');
        kop.removeAttribute('tabindex');
        kop.removeAttribute('aria-expanded');
        kop.removeAttribute('aria-controls');
        accordeon.classList.add('is-open');
        inhoud.inert = false;              // op desktop staat alles open
      } else {
        kop.setAttribute('role', 'button');
        kop.setAttribute('tabindex', '0');
        kop.setAttribute('aria-controls', inhoud.id);
        zet(accordeon.classList.contains('is-open'));
      }
    };

    kop.addEventListener('click', () => {
      if (desktop.matches) return;
      zet(!accordeon.classList.contains('is-open'));
    });
    kop.addEventListener('keydown', (e) => {
      if (desktop.matches) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        zet(!accordeon.classList.contains('is-open'));
      }
    });

    stelIn();
    desktop.addEventListener('change', stelIn);
  });
})();
